import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Sitemap } from '../components/Sitemap';
import { BookIcon, BookOpenIcon, BriefcaseIcon, CheckCircleIcon, ChevronDownIcon, ExternalLinkIcon, GlobeIcon, GraduationCapIcon, HeadphonesIcon, LaptopIcon, LayoutGridIcon, ListIcon, SearchIcon, StarIcon, ThumbsUpIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
// Sample resources data
const RESOURCES = [{
  id: 1,
  type: 'book',
  title: {
    en: 'English Grammar in Use',
    ar: 'قواعد اللغة الإنجليزية في الاستخدام'
  },
  author: 'Raymond Murphy',
  description: {
    en: "The world's best-selling grammar book for learners of English, covering all the key grammar points with clear explanations and examples.",
    ar: 'كتاب قواعد اللغة الأكثر مبيعًا في العالم لمتعلمي اللغة الإنجليزية، يغطي جميع نقاط القواعد الرئيسية مع شروحات وأمثلة واضحة.'
  },
  image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.8,
  price: '$24.99',
  level: 'beginner-intermediate',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: true
}, {
  id: 2,
  type: 'book',
  title: {
    en: 'Essential English Vocabulary for Arabic Speakers',
    ar: 'المفردات الإنجليزية الأساسية للمتحدثين باللغة العربية'
  },
  author: 'Dr. Amira Hassan',
  description: {
    en: 'A specialized vocabulary book designed specifically for Arabic speakers, with translations and cultural context.',
    ar: 'كتاب مفردات متخصص مصمم خصيصًا للمتحدثين باللغة العربية، مع ترجمات وسياق ثقافي.'
  },
  image: 'https://images.unsplash.com/photo-1585520753590-15ea7e4b13b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.7,
  price: '$19.95',
  level: 'beginner',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: true
}, {
  id: 3,
  type: 'course',
  title: {
    en: 'Business English Mastery',
    ar: 'إتقان اللغة الإنجليزية للأعمال'
  },
  author: 'Professional English Academy',
  description: {
    en: 'A comprehensive online course focused on business communication, presentations, and professional writing.',
    ar: 'دورة شاملة عبر الإنترنت تركز على التواصل التجاري والعروض التقديمية والكتابة الاحترافية.'
  },
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.9,
  price: '$129',
  level: 'intermediate-advanced',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: true
}, {
  id: 4,
  type: 'course',
  title: {
    en: 'Pronunciation Perfection',
    ar: 'إتقان النطق'
  },
  author: 'Speak Clearly Institute',
  description: {
    en: 'Master English pronunciation with this specialized course focusing on sounds that Arabic speakers typically find challenging.',
    ar: 'أتقن النطق الإنجليزي مع هذه الدورة المتخصصة التي تركز على الأصوات التي عادة ما يجد المتحدثون باللغة العربية صعوبة فيها.'
  },
  image: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.6,
  price: '$89',
  level: 'all-levels',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: false
}, {
  id: 5,
  type: 'tool',
  title: {
    en: 'VocabBuilder Pro',
    ar: 'برو بناء المفردات'
  },
  author: 'LanguageTech Inc.',
  description: {
    en: 'An AI-powered vocabulary building app with spaced repetition system and contextual examples.',
    ar: 'تطبيق لبناء المفردات مدعوم بالذكاء الاصطناعي مع نظام التكرار المتباعد وأمثلة سياقية.'
  },
  image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.8,
  price: '$4.99/month',
  level: 'all-levels',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: true
}, {
  id: 6,
  type: 'tool',
  title: {
    en: 'GrammarCheck Plus',
    ar: 'فحص القواعد بلس'
  },
  author: 'EduTools',
  description: {
    en: 'Advanced grammar checking tool designed for English learners with explanations of errors in Arabic.',
    ar: 'أداة متقدمة للتحقق من القواعد مصممة لمتعلمي اللغة الإنجليزية مع شرح للأخطاء باللغة العربية.'
  },
  image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.5,
  price: '$6.99/month',
  level: 'intermediate-advanced',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: false
}, {
  id: 7,
  type: 'book',
  title: {
    en: 'English Idioms and Phrases',
    ar: 'التعبيرات والعبارات الإنجليزية'
  },
  author: 'Dr. James Wilson',
  description: {
    en: 'A comprehensive collection of English idioms and phrases with explanations and usage examples.',
    ar: 'مجموعة شاملة من التعبيرات والعبارات الإنجليزية مع شروحات وأمثلة على الاستخدام.'
  },
  image: 'https://images.unsplash.com/photo-1550399105-c4db5fb85c18?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.6,
  price: '$22.50',
  level: 'intermediate-advanced',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: true
}, {
  id: 8,
  type: 'course',
  title: {
    en: 'IELTS Preparation Masterclass',
    ar: 'دورة إعداد الآيلتس الرئيسية'
  },
  author: 'Global Test Prep',
  description: {
    en: 'Comprehensive preparation course for the IELTS exam with practice tests and personalized feedback.',
    ar: 'دورة تحضيرية شاملة لامتحان الآيلتس مع اختبارات تدريبية وملاحظات مخصصة.'
  },
  image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.9,
  price: '$199',
  level: 'intermediate-advanced',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: true
}, {
  id: 9,
  type: 'tool',
  title: {
    en: 'SpeakConfident AI',
    ar: 'التحدث بثقة بالذكاء الاصطناعي'
  },
  author: 'Language Innovations',
  description: {
    en: 'AI-powered speaking practice tool that provides instant feedback on pronunciation and fluency.',
    ar: 'أداة ممارسة التحدث المدعومة بالذكاء الاصطناعي التي توفر ملاحظات فورية حول النطق والطلاقة.'
  },
  image: 'https://images.unsplash.com/photo-1593642533144-3d62aa4783ec?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  rating: 4.7,
  price: '$9.99/month',
  level: 'all-levels',
  affiliateLink: 'https://example.com/affiliate-link',
  isPartner: true
}];
const CATEGORIES = [{
  id: 'all',
  label: {
    en: 'All Resources',
    ar: 'جميع الموارد'
  },
  icon: LayoutGridIcon
}, {
  id: 'book',
  label: {
    en: 'Books',
    ar: 'الكتب'
  },
  icon: BookIcon
}, {
  id: 'course',
  label: {
    en: 'Courses',
    ar: 'الدورات'
  },
  icon: GraduationCapIcon
}, {
  id: 'tool',
  label: {
    en: 'Tools',
    ar: 'الأدوات'
  },
  icon: LaptopIcon
}];
const LEVELS = [{
  id: 'all',
  label: {
    en: 'All Levels',
    ar: 'جميع المستويات'
  }
}, {
  id: 'beginner',
  label: {
    en: 'Beginner',
    ar: 'مبتدئ'
  }
}, {
  id: 'intermediate',
  label: {
    en: 'Intermediate',
    ar: 'متوسط'
  }
}, {
  id: 'advanced',
  label: {
    en: 'Advanced',
    ar: 'متقدم'
  }
}];
export function RecommendedResources() {
  const {
    isArabic
  } = useLanguage();
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeLevel, setActiveLevel] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  // Filter resources based on category, level, and search query
  const filteredResources = RESOURCES.filter(resource => {
    const matchesCategory = activeCategory === 'all' || resource.type === activeCategory;
    const matchesLevel = activeLevel === 'all' || resource.level.includes(activeLevel) || resource.level === 'all-levels';
    const matchesSearch = searchQuery === '' || resource.title[isArabic ? 'ar' : 'en'].toLowerCase().includes(searchQuery.toLowerCase()) || resource.description[isArabic ? 'ar' : 'en'].toLowerCase().includes(searchQuery.toLowerCase()) || resource.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesLevel && matchesSearch;
  });
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-4232">
      <Sitemap currentPage={{
      en: 'Recommended Resources',
      ar: 'الموارد الموصى بها'
    }} data-id="element-4233" />
      <div className="max-w-7xl mx-auto" data-id="element-4234">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-4235">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-4236">
            {isArabic ? 'الموارد الموصى بها' : 'Recommended Resources'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-4237">
            {isArabic ? 'مجموعة مختارة من أفضل الكتب والدورات والأدوات لتعلم اللغة الإنجليزية' : 'A curated selection of the best books, courses, and tools for learning English'}
          </p>
        </div>
        {/* Search and Filter */}
        <div className="mb-10" data-id="element-4238">
          <div className="relative max-w-md mx-auto mb-6" data-id="element-4239">
            <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" data-id="element-4240" />
            <input type="text" placeholder={isArabic ? 'ابحث عن موارد...' : 'Search resources...'} className="w-full pl-12 pr-4 py-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent transition-all duration-200" dir={isArabic ? 'rtl' : 'ltr'} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-4241" />
          </div>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-4242">
            <div className="flex overflow-x-auto space-x-4 pb-2 md:pb-0" data-id="element-4243">
              {CATEGORIES.map(category => <button key={category.id} className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap ${activeCategory === category.id ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-medium' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory(category.id)} data-id="element-4244">
                  <category.icon className="w-4 h-4" data-id="element-4245" />
                  <span data-id="element-4246">
                    {isArabic ? category.label.ar : category.label.en}
                  </span>
                </button>)}
            </div>
            <div className="flex items-center gap-4" data-id="element-4247">
              <div className="relative" data-id="element-4248">
                <button className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-700 dark:text-gray-300" onClick={() => document.getElementById('level-dropdown')?.classList.toggle('hidden')} data-id="element-4249">
                  <span data-id="element-4250">
                    {isArabic ? LEVELS.find(l => l.id === activeLevel)?.label.ar : LEVELS.find(l => l.id === activeLevel)?.label.en}
                  </span>
                  <ChevronDownIcon className="w-4 h-4" data-id="element-4251" />
                </button>
                <div id="level-dropdown" className="absolute z-10 right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 hidden" data-id="element-4252">
                  {LEVELS.map(level => <button key={level.id} className="w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300" onClick={() => {
                  setActiveLevel(level.id);
                  document.getElementById('level-dropdown')?.classList.add('hidden');
                }} data-id="element-4253">
                      {isArabic ? level.label.ar : level.label.en}
                    </button>)}
                </div>
              </div>
              <div className="flex border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden" data-id="element-4254">
                <button className={`p-2 ${viewMode === 'grid' ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setViewMode('grid')} aria-label="Grid view" data-id="element-4255">
                  <LayoutGridIcon className="w-5 h-5" data-id="element-4256" />
                </button>
                <button className={`p-2 ${viewMode === 'list' ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setViewMode('list')} aria-label="List view" data-id="element-4257">
                  <ListIcon className="w-5 h-5" data-id="element-4258" />
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Resources Display */}
        {viewMode === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4259">
            {filteredResources.map(resource => <div key={resource.id} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 overflow-hidden flex flex-col h-full" data-id="element-4260">
                <div className="relative" data-id="element-4261">
                  <img src={resource.image} alt={isArabic ? resource.title.ar : resource.title.en} className="w-full h-48 object-cover" data-id="element-4262" />
                  <div className="absolute top-4 left-4 px-2 py-1 rounded text-xs font-bold uppercase" data-id="element-4263">
                    {resource.type === 'book' && <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 px-2 py-1 rounded" data-id="element-4264">
                        {isArabic ? 'كتاب' : 'Book'}
                      </span>}
                    {resource.type === 'course' && <span className="bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 px-2 py-1 rounded" data-id="element-4265">
                        {isArabic ? 'دورة' : 'Course'}
                      </span>}
                    {resource.type === 'tool' && <span className="bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 px-2 py-1 rounded" data-id="element-4266">
                        {isArabic ? 'أداة' : 'Tool'}
                      </span>}
                  </div>
                  {resource.isPartner && <div className="absolute top-4 right-4 bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-300 text-xs font-bold px-2 py-1 rounded flex items-center gap-1" data-id="element-4267">
                      <ThumbsUpIcon className="w-3 h-3" data-id="element-4268" />
                      {isArabic ? 'شريك موصى به' : 'RECOMMENDED PARTNER'}
                    </div>}
                </div>
                <div className="p-5 flex-1 flex flex-col" data-id="element-4269">
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-1" data-id="element-4270">
                    {isArabic ? resource.title.ar : resource.title.en}
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mb-3" data-id="element-4271">
                    {resource.author}
                  </p>
                  <div className="flex items-center mb-3" data-id="element-4272">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < Math.floor(resource.rating) ? 'text-amber-400' : 'text-gray-300 dark:text-gray-600'}`} fill={i < Math.floor(resource.rating) ? 'currentColor' : 'none'} data-id="element-4273" />)}
                    <span className="ml-2 text-sm text-gray-600 dark:text-gray-400" data-id="element-4274">
                      {resource.rating}
                    </span>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300 mb-4 flex-1 text-sm" data-id="element-4275">
                    {isArabic ? resource.description.ar : resource.description.en}
                  </p>
                  <div className="flex items-center justify-between mt-2" data-id="element-4276">
                    <span className="font-medium text-gray-900 dark:text-white" data-id="element-4277">
                      {resource.price}
                    </span>
                    <a href={resource.affiliateLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors" data-id="element-4278">
                      <span data-id="element-4279">{isArabic ? 'عرض المورد' : 'View Resource'}</span>
                      <ExternalLinkIcon className="w-3 h-3" data-id="element-4280" />
                    </a>
                  </div>
                </div>
              </div>)}
          </div> : <div className="space-y-6" data-id="element-4281">
            {filteredResources.map(resource => <div key={resource.id} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 overflow-hidden" data-id="element-4282">
                <div className="flex flex-col md:flex-row" data-id="element-4283">
                  <div className="md:w-1/4 relative" data-id="element-4284">
                    <img src={resource.image} alt={isArabic ? resource.title.ar : resource.title.en} className="w-full h-48 md:h-full object-cover" data-id="element-4285" />
                    <div className="absolute top-4 left-4 px-2 py-1 rounded text-xs font-bold uppercase" data-id="element-4286">
                      {resource.type === 'book' && <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 px-2 py-1 rounded" data-id="element-4287">
                          {isArabic ? 'كتاب' : 'Book'}
                        </span>}
                      {resource.type === 'course' && <span className="bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 px-2 py-1 rounded" data-id="element-4288">
                          {isArabic ? 'دورة' : 'Course'}
                        </span>}
                      {resource.type === 'tool' && <span className="bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 px-2 py-1 rounded" data-id="element-4289">
                          {isArabic ? 'أداة' : 'Tool'}
                        </span>}
                    </div>
                  </div>
                  <div className="md:w-3/4 p-6" data-id="element-4290">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4" data-id="element-4291">
                      <div data-id="element-4292">
                        <div className="flex items-center gap-2 mb-1" data-id="element-4293">
                          <h3 className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-4294">
                            {isArabic ? resource.title.ar : resource.title.en}
                          </h3>
                          {resource.isPartner && <span className="bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-300 text-xs font-bold px-2 py-0.5 rounded flex items-center gap-1" data-id="element-4295">
                              <ThumbsUpIcon className="w-3 h-3" data-id="element-4296" />
                              {isArabic ? 'شريك موصى به' : 'RECOMMENDED PARTNER'}
                            </span>}
                        </div>
                        <p className="text-sm text-gray-500 dark:text-gray-400 mb-3" data-id="element-4297">
                          {resource.author}
                        </p>
                        <div className="flex items-center mb-3" data-id="element-4298">
                          {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < Math.floor(resource.rating) ? 'text-amber-400' : 'text-gray-300 dark:text-gray-600'}`} fill={i < Math.floor(resource.rating) ? 'currentColor' : 'none'} data-id="element-4299" />)}
                          <span className="ml-2 text-sm text-gray-600 dark:text-gray-400" data-id="element-4300">
                            {resource.rating}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col items-end" data-id="element-4301">
                        <span className="font-medium text-lg text-gray-900 dark:text-white mb-2" data-id="element-4302">
                          {resource.price}
                        </span>
                        <a href={resource.affiliateLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-4303">
                          <span data-id="element-4304">
                            {isArabic ? 'عرض المورد' : 'View Resource'}
                          </span>
                          <ExternalLinkIcon className="w-4 h-4" data-id="element-4305" />
                        </a>
                      </div>
                    </div>
                    <p className="text-gray-600 dark:text-gray-300 mt-4" data-id="element-4306">
                      {isArabic ? resource.description.ar : resource.description.en}
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2" data-id="element-4307">
                      {resource.level.split('-').map((level, index) => <span key={index} className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded text-xs" data-id="element-4308">
                          {level === 'beginner' && (isArabic ? 'مبتدئ' : 'Beginner')}
                          {level === 'intermediate' && (isArabic ? 'متوسط' : 'Intermediate')}
                          {level === 'advanced' && (isArabic ? 'متقدم' : 'Advanced')}
                          {level === 'all' && (isArabic ? 'جميع المستويات' : 'All Levels')}
                        </span>)}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>}
        {/* Empty State */}
        {filteredResources.length === 0 && <div className="text-center py-16" data-id="element-4309">
            <div className="mb-4" data-id="element-4310">
              <SearchIcon className="w-12 h-12 mx-auto text-gray-400 dark:text-gray-500" data-id="element-4311" />
            </div>
            <h3 className="text-xl font-medium text-gray-900 dark:text-white mb-2" data-id="element-4312">
              {isArabic ? 'لم يتم العثور على نتائج' : 'No results found'}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto" data-id="element-4313">
              {isArabic ? 'لم نتمكن من العثور على أي موارد تطابق معايير البحث الخاصة بك. يرجى تجربة مصطلحات بحث مختلفة أو تصفية مختلفة.' : "We couldn't find any resources matching your search criteria. Please try different search terms or filters."}
            </p>
            <button onClick={() => {
          setSearchQuery('');
          setActiveCategory('all');
          setActiveLevel('all');
        }} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-4314">
              {isArabic ? 'إعادة ضبط الفلاتر' : 'Reset filters'}
            </button>
          </div>}
        {/* Disclosure */}
        <div className="mt-16 bg-gray-50 dark:bg-gray-800/50 rounded-xl p-6 text-sm text-gray-600 dark:text-gray-400" data-id="element-4315">
          <div className="flex items-start gap-3" data-id="element-4316">
            <InfoIcon className="w-5 h-5 text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-4317" />
            <div data-id="element-4318">
              <h3 className="font-medium text-gray-900 dark:text-white mb-2" data-id="element-4319">
                {isArabic ? 'إفصاح عن الشراكة' : 'Partnership Disclosure'}
              </h3>
              <p data-id="element-4320">
                {isArabic ? 'تحتوي بعض الروابط على هذه الصفحة على روابط تابعة، مما يعني أننا قد نكسب عمولة إذا قمت بالشراء من خلالها. نوصي فقط بالموارد التي نعتقد أنها ستكون مفيدة لمتعلمي اللغة الإنجليزية. الموارد المميزة بعلامة "شريك موصى به" هي من شركائنا الذين قمنا بمراجعة منتجاتهم بعناية.' : 'Some links on this page contain affiliate links, which means we may earn a commission if you purchase through them. We only recommend resources we believe will be helpful for English learners. Resources marked with "Recommended Partner" are from our partners whose products we have carefully reviewed.'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
// Simple info icon component
function InfoIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-4321">
      <circle cx="12" cy="12" r="10" data-id="element-4322" />
      <line x1="12" y1="16" x2="12" y2="12" data-id="element-4323" />
      <line x1="12" y1="8" x2="12.01" y2="8" data-id="element-4324" />
    </svg>;
}